import gql from 'graphql-tag';

export default gql`
  mutation submitKeepInTouchForm($input: SubmitKeepInTouchFormRequest!) {
    submitKeepInTouchForm(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
